import { Tabs } from 'antd';
import styled from 'styled-components';

export const StyledTabs = styled(Tabs)`
  padding: 2px 0;

  & .ant-tabs-tab {
    padding: 13px 24px;

    & + .ant-tabs-tab {
      margin-left: 2px;
    }
  }
`;
